import { Component } from '@angular/core';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { combineLatest } from 'rxjs';
import { Location } from '@angular/common';

@Component({
    selector: 'nova-redirect',
    template: ' ',
    standalone: true
})
export class RedirectComponent {
    constructor(
        route: ActivatedRoute,
        private readonly location: Location
    ) {
        combineLatest([route.parent.url, route.url, route.data]).subscribe(([parent, child, data]) => {
            const parentPath = parent && parent.length > 0 ? parent[0].path : '/';
            this.redirect(child, parentPath, data);
        });
    }

    redirect(urlSegments: UrlSegment[], parentPath: string, data: any) {
        if (!urlSegments.length) {
            return;
        }

        urlSegments.forEach((val) => {
            if (data.from === val.path && data.to) {
                val.path = data.to;
            }
        });
        this.location.go(parentPath + '/' + urlSegments.map((val) => val.path).join('/'));
    }
}
